export enum UnitSystem {
    SI,
    MKSA,
    Imperial
}
